import { defineComponent as c, mergeModels as m, useModel as f, createElementBlock as r, openBlock as l, mergeProps as g, unref as e, createElementVNode as x, normalizeClass as s, createVNode as p, withCtx as v, createCommentVNode as S, renderSlot as I } from "vue";
import o from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/ExpandableSection/expandable-section.js";
import { AngleRightIcon as B } from "../../packages/icons/dist/esm/icons/angle-right-icon.js";
import b from "../Button.vue2.js";
import { useOUIAProps as k } from "../../helpers/ouia.js";
const M = /* @__PURE__ */ c({
  name: "PfExpandableSectionToggle",
  __name: "ExpandableSectionToggle",
  props: /* @__PURE__ */ m({
    contentId: {},
    direction: { default: "down" },
    truncate: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  }, {
    expanded: { type: Boolean, default: !1 },
    expandedModifiers: {}
  }),
  emits: ["update:expanded"],
  setup(t) {
    const d = t, u = k({ id: d.ouiaId, safe: d.ouiaSafe }), n = f(t, "expanded");
    return (a, i) => (l(), r("div", g(e(u), {
      class: [e(o).expandableSection, {
        [e(o).modifiers.expanded]: n.value,
        [e(o).modifiers.truncate]: a.truncate
      }]
    }), [
      x("div", {
        class: s(`${e(o).expandableSection}__toggle`)
      }, [
        p(b, {
          variant: "link",
          inline: !!a.truncate,
          "aria-controls": a.contentId,
          "aria-expanded": n.value,
          onClick: i[0] || (i[0] = (y) => n.value = !n.value)
        }, {
          default: v(() => [
            a.truncate ? S("", !0) : (l(), r("span", {
              key: 0,
              class: s([e(o).expandableSectionToggleIcon, {
                [e(o).modifiers.expandTop]: n.value && a.direction === "up"
              }])
            }, [
              p(e(B), { "aria-hidden": "" })
            ], 2)),
            I(a.$slots, "default")
          ]),
          _: 3
        }, 8, ["inline", "aria-controls", "aria-expanded"])
      ], 2)
    ], 16));
  }
});
export {
  M as default
};
